import * as React from "react";
import { useState } from "react";
import "../../components/views/profiles/profilesViewStyles.css";
import { useTranslation } from "react-i18next";
import { ProfilesView } from "../../components/views/profiles/ProfilesView";
import { useAuth } from "../../context/Auth";
import { logout } from "../../services/user.service";
import LogoutConfirmModal from "../../components/views/modals/LogoutConfirmModal";
import { focusManager } from "../../utils/Focus";
export var ProfilesScreen = function () {
    var t = useTranslation().t;
    var _a = useAuth(), user = _a.user, profile = _a.profile, profiles = _a.profiles;
    var _b = useState(false), logoutModal = _b[0], setLogoutModal = _b[1];
    var handleOnLogout = function () {
        logout().then(function () {
            window.close();
        });
    };
    var handleOnClose = function () {
        focusManager.popLayer();
        setLogoutModal(false);
    };
    var handleLogOut = function () {
        focusManager.pushLayer({ groupName: "logoutModal", index: 0 });
        setLogoutModal(true);
    };
    return (React.createElement("div", null,
        user && profiles ? (React.createElement(ProfilesView, { key: "profiles-view", t: t, profiles: profiles, userName: user.firstName, userMail: user.email, handleLogOut: handleLogOut, selectedProfile: profile })) : null,
        logoutModal && (React.createElement("div", { id: "modal-overlay", tabIndex: 0, className: "modal-overlay", key: "logout-confirm-modal" },
            React.createElement(LogoutConfirmModal, { onClose: handleOnClose, onLogout: handleOnLogout })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/screens/ProfilesScreen/ProfilesScreen.tsx
// module id = 152
// module chunks = 1